import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
    reformatDate,
    reformatTime,
} from "../../util/commonFunctions";

class EventList extends Component {
    render() {
        return (
            <div className="search-suggetion-list">
                <h3>{this.props.title}</h3>
                <div className="search-suggetion-block">
                    {this.props.searchObjectResults.map((item, index) => {
                        return (
                            <div className="search-suggetion-item" key={index}>
                                <div
                                    className="search-suggetion-img search-event-width"
                                    onClick={() => {
                                        window.location.href = item.registrationUrl.replace(/https?:\/\/[^\/]+/i, "")
                                    }
                                    }
                                >
                                    {item.url &&
                                        <img src={item.url} />
                                    }
                                    {!item.url &&
                                        <img src="/assets/ausbizevents_generic.png" />
                                    }
                                </div>
                                <div
                                    className="search-suggetion-info"
                                    onClick={() => {
                                        window.location.href = item.registrationUrl.replace(/https?:\/\/[^\/]+/i, "")
                                    }
                                    }
                                >
                                    <h4>{item.title}</h4>

                                    {item.isUpcomingEvent &&
                                        <span>
                                            {reformatDate(item.date)}  - {reformatTime(item.startTime)} AEDT
                                        </span>
                                    }

                                    {!item.isUpcomingEvent &&
                                        <span>
                                            Watch on demand
                                        </span>
                                    }
                                </div>
                            </div>
                        );
                    })
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(EventList);